export default class PhoneNumber {
    number: string;
    type: string;

    constructor(number: string, type: string) {
        this.number = number;
        this.type = type;
    }
}
